module.exports = __webpack_public_path__ + "static/media/Logo-2.16c21354.png";